<script>
export default {
  name: 'RoundedBox',

  props: {
    title: {
      type: String,
      default: '',
    },
    largeTitle: {
      type: Boolean,
      default: false,
    },
    fullsize: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    textContent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <v-sheet
    elevation="3"
    class="rounded-box"
    :class="[{ fullsize }, { center }, { 'text-content': textContent }]"
  >
    <div v-if="title" class="card-header">
      <v-skeleton-loader
        v-if="title === 'loading'"
        type="heading"
        width="100%"
        class="card-title d-flex justify-center"
      >
      </v-skeleton-loader>
      <h1 v-else-if="largeTitle" class="card-title">
        {{ title }}
      </h1>

      <h3 v-else-if="title && !largeTitle" class="card-title">
        {{ title }}
      </h3>
      <hr v-if="title && !largeTitle" class="header-underline" />
    </div>
    <slot />
  </v-sheet>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.rounded-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  // max-width: 360px;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 4px auto 16px auto;
  padding: 16px;
  background-color: white;

  .app & {
    max-width: 360px;
  }

  .admin & {
    height: 620px;
  }

  .sm & {
    width: 100%;
    // max-width: 100%;
    max-width: 420px;
  }
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .card-title {
    margin-top: 0.5rem;
    margin-bottom: 0;
    text-align: center;
  }
}

.fullsize {
  position: absolute;
  width: 360px;
  // height: 660px;

  .app & {
    position: relative;
    min-height: 660px;
    max-height: fit-content;

    .sm & {
      position: relative;
      min-height: calc(100vh - #{$top-bar-height} - 16px - 4px);
      height: fit-content;
      // width: 100%;
      // min-width: 100%;
      // margin: 0;
    }
  }
}

// @media screen and (max-height: 800px) {
//   .app .fullsize {
//     min-height: calc(100vh - #{$top-bar-height} - 16px);
//     height: fit-content;
//   }
// }

.text-content {
  justify-content: flex-start;

  .header-underline {
    margin-bottom: 1.5rem;
  }

  .md &,
  .lg &,
  .xl & {
    min-width: 360px;
    width: 60%;
    max-width: 720px;
    padding: 2rem;
  }
}

.center {
  align-items: center;
}
</style>
